/* Gymatics personalisation: our own replacement for the Globo Product Options app.
   Markup: snippets/gymatics-personalise.liquid. Styles: assets/gymatics-personalise.css.
   - <gm-personalise> drives the product-page form (toggle, counter, live tag preview, icons).
   - GymaticsPersonalise.validate / .transform are called from assets/product-form.js on submit.
   - A paid name adds the NameTag fee product as its own line, linked by _gm_pz (item) and
     _gm_pz_for (fee). syncCart() keeps the fee quantity equal to its item's quantity and
     removes the fee when the item goes. */
(function () {
  if (window.GymaticsPersonalise) return;

  // Letters the Rensol nametag font can print (from Rensol.ttf's cmap, 17 Oct 2026).
  var PRINTABLE = /^[A-Za-z0-9À-ÖØ-öø-ÿŁłŒœŠšŸŽž&'’.\- ]$/;

  function badChars(text) {
    var out = [];
    Array.from(text).forEach(function (ch) { // by code point, so emoji stay whole
      if (!PRINTABLE.test(ch) && out.indexOf(ch) === -1) out.push(ch);
    });
    return out;
  }

  function tidy(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  function linkId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  class GmPersonalise extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.mode = this.dataset.mode;
      this.max = parseInt(this.dataset.max, 10) || 12;
      this.body = this.querySelector('[data-gm-pz-body]');
      this.name = this.querySelector('[data-gm-pz-name]');
      this.count = this.querySelector('[data-gm-pz-count]');
      this.error = this.querySelector('[data-gm-pz-error]');
      this.tagName_ = this.querySelector('[data-gm-pz-tag-name]');
      this.placeholderName = this.tagName_ ? this.tagName_.textContent : '';

      var self = this;
      this.querySelectorAll('[data-gm-pz-on]').forEach(function (r) {
        r.addEventListener('change', function () { self.applyOn(true); });
      });
      if (this.name) {
        this.name.addEventListener('input', function () {
          self.clearError(self.name);
          self.update();
        });
        this.name.addEventListener('blur', function () { self.name.value = tidy(self.name.value); self.update(); });
      }
      this.querySelectorAll('[data-gm-pz-icon], [data-gm-pz-side]').forEach(function (r) {
        r.addEventListener('change', function () { self.update(); });
      });
      this.querySelectorAll('[data-gm-pz-colour]').forEach(function (r) {
        r.addEventListener('change', function () {
          var l = self.querySelector('[data-gm-pz-colour-label]');
          if (l) l.textContent = r.dataset.label || r.value;
          self.clearError(r.closest('[data-gm-pz-group-required]'));
        });
      });
      this.querySelectorAll('[data-gm-pz-required]').forEach(function (el) {
        el.addEventListener('input', function () { self.clearError(el); });
      });
      var file = this.querySelector('[data-gm-pz-file]');
      if (file) file.addEventListener('change', function () { self.onFile(file); });

      this.hideExpressCheckout();
      this.applyOn(false);
      this.update();
      var self2 = this;
      if (document.fonts) {
        if (document.fonts.ready) document.fonts.ready.then(function () { self2.fitTag(); });
        if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { self2.fitTag(); });
        if (document.fonts.load) document.fonts.load('700 20px Comfortaa').then(function () { self2.fitTag(); }, function () {});
      }
      if (window.ResizeObserver) {
        var tagEl = this.querySelector('[data-gm-pz-tag]');
        if (tagEl) new ResizeObserver(function () { self2.fitTag(); }).observe(tagEl);
      }
    }

    isOn() {
      if (this.mode !== 'paid') return true;
      var yes = this.querySelector('[data-gm-pz-on][value="yes"]');
      return !!(yes && yes.checked);
    }

    applyOn(animate) {
      if (!this.body) return;
      var on = this.isOn();
      this.classList.toggle('is-off', !on);
      if (animate && on) {
        this.body.classList.remove('gm-pz__body--in');
        void this.body.offsetWidth;
        this.body.classList.add('gm-pz__body--in');
      }
      this.body.hidden = !on;
      this.body.querySelectorAll('input, textarea, select').forEach(function (el) {
        if (!el.hasAttribute('data-gm-pz-link')) el.disabled = !on;
      });
      if (!on) this.clearError(this.name);
      if (on && animate && this.name) this.name.focus({ preventScroll: true });
    }

    update() {
      if (this.name && this.count) {
        var n = this.name.value.length;
        this.count.textContent = n + '/' + this.max;
        this.count.classList.toggle('is-full', n >= this.max);
      }
      if (this.tagName_) {
        var v = this.name ? tidy(this.name.value) : '';
        this.tagName_.textContent = v || this.placeholderName;
        this.tagName_.classList.toggle('is-placeholder', !v);
      }

      var icon = this.querySelector('[data-gm-pz-icon]:checked');
      var key = icon && icon.value ? icon.dataset.iconKey : '';
      var glyph = '';
      if (key) {
        // Size from the symbol's own shape, so the icon is 7.5 mm tall like the print
        var sym = document.getElementById('gm-pz-i-' + key);
        var vb = sym && sym.getAttribute('viewBox') ? sym.getAttribute('viewBox').split(' ') : [0, 0, 1, 1];
        glyph = '<svg class="gm-pz__svg" focusable="false" aria-hidden="true" viewBox="' + vb.join(' ') + '" style="aspect-ratio:' + vb[2] + ' / ' + vb[3] + '">' +
          '<use href="#gm-pz-i-' + key + '"></use></svg>';
      }
      var label = this.querySelector('[data-gm-pz-icon-label]');
      if (label) label.textContent = icon && icon.value ? (icon.dataset.label || icon.value) : (label.dataset.none || 'None');
      var sides = this.querySelector('[data-gm-pz-sides]');
      if (sides) {
        sides.hidden = !glyph;
        sides.querySelectorAll('input').forEach(function (r) { r.disabled = !glyph; });
      }
      var side = this.querySelector('[data-gm-pz-side]:checked');
      side = side ? side.value : 'Left of name';
      var left = this.querySelector('[data-gm-pz-tag-left]');
      var right = this.querySelector('[data-gm-pz-tag-right]');
      if (left) left.innerHTML = glyph && side !== 'Right of name' ? glyph : '';
      if (right) right.innerHTML = glyph && side !== 'Left of name' ? glyph : '';
      if (right) right.classList.toggle('is-mirrored', side === 'Both sides' && /Cartwheel|Moon|Rainbow|Lightning/.test(icon ? icon.value : ''));
      if (this.isOn() === false && sides) sides.querySelectorAll('input').forEach(function (r) { r.disabled = true; });
      this.fitTag();
    }

    // Like gen_plate.layout_text: name + icons + 2 mm gaps must fit in 50 mm, so long names shrink.
    fitTag() {
      var tag = this.querySelector('[data-gm-pz-tag]');
      var group = this.querySelector('[data-gm-pz-tag-group]');
      var name = this.tagName_;
      if (!tag || !group || !name) return;
      name.style.fontSize = '';
      var mm = tag.clientWidth / 62.4;
      if (!mm) return;
      var nameW = name.getBoundingClientRect().width;
      var groupW = 0;
      Array.prototype.forEach.call(group.children, function (c) {
        if (c.firstChild) groupW += c.getBoundingClientRect().width + (groupW ? 2 * mm : 0);
      });
      var room = 50 * mm - (groupW - nameW);
      if (nameW > room && nameW > 0) {
        name.style.fontSize = (parseFloat(getComputedStyle(name).fontSize) * room / nameW) + 'px';
      }
    }

    onFile(input) {
      var label = this.querySelector('[data-gm-pz-file-label]');
      var f = input.files && input.files[0];
      if (f && f.size > 20 * 1024 * 1024) {
        input.value = '';
        this.showError(this.dataset.msgBig || 'That file is over 20 MB. Please choose a smaller one.', input.closest('.gm-pz__drop'));
        f = null;
      }
      if (label) {
        if (label._empty == null) label._empty = label.innerHTML; // the page's own (translated) empty text
        label.innerHTML = f
          ? '<strong></strong> ' + (this.dataset.msgReady || 'ready to upload · tap to change')
          : label._empty;
        if (f) label.querySelector('strong').textContent = f.name;
      }
      input.closest('.gm-pz__drop').classList.toggle('has-file', !!f);
    }

    hideExpressCheckout() {
      // "Buy it now" skips the cart, so it would skip the NameTag charge and the checks here.
      var scope = this.closest('product-form') || this.closest('form');
      if (!scope) return;
      var container = scope.parentElement || scope;
      container.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]').forEach(function (el) {
        el.hidden = true;
        el.style.display = 'none';
      });
    }

    showError(msg, field) {
      if (this.error) {
        this.error.textContent = msg;
        this.error.hidden = false;
      }
      if (field) field.classList.add('is-invalid');
    }

    clearError(field) {
      if (field) field.classList.remove('is-invalid');
      if (this.error && !this.querySelector('.is-invalid')) this.error.hidden = true;
    }

    // Returns an error message, or null when the form can be added to the cart.
    validate() {
      if (!this.isOn()) return null;
      var self = this;
      if (this.name) this.name.value = tidy(this.name.value);
      this.update();

      if (this.mode === 'design') {
        var missing = [];
        this.querySelectorAll('[data-gm-pz-required]').forEach(function (el) {
          if (!el.value.trim()) missing.push(el);
        });
        var colours = this.querySelector('[data-gm-pz-group-required]');
        if (colours && !colours.querySelector('input:checked')) missing.push(colours);
        if (missing.length) {
          missing.forEach(function (el) { el.classList.add('is-invalid'); });
          this.showError(this.dataset.msgDesign);
          var first = missing[0].matches('input, textarea') ? missing[0] : missing[0].querySelector('input');
          if (first) first.focus();
          return this.dataset.msgDesign;
        }
        return null;
      }

      var v = this.name ? this.name.value : '';
      if (!v) {
        this.showError(this.dataset.msgRequired, this.name);
        this.name.focus();
        return this.dataset.msgRequired;
      }
      var bad = badChars(v);
      if (bad.length) {
        var msg = this.dataset.msgChars + bad.join(' ');
        this.showError(msg, this.name);
        this.name.focus();
        return msg;
      }
      return null;
    }

    // Adds the link id and, for a paid name, the NameTag fee line to the add-to-cart request.
    transform(formData) {
      // Drop empty answers ("No icon", optional fields) so they don't show as blank lines on the order
      Array.from(formData.keys()).forEach(function (k) {
        var v = formData.get(k);
        if (k.indexOf('properties[') === 0 && typeof v === 'string' && !v.trim()) formData.delete(k);
        if (k.indexOf('properties[') === 0 && typeof v !== 'string' && v && !v.size) formData.delete(k); // no file chosen
      });
      if (!formData.get('properties[Name Icon]')) formData.delete('properties[Icon Side]');

      var fee = this.dataset.feeVariant;
      if (this.mode !== 'paid' || !fee || !this.isOn()) {
        formData.delete('properties[_gm_pz]');
        formData.delete('properties[_gm_pz_fee]');
        return formData;
      }

      var id = linkId();
      var qty = formData.get('quantity') || '1';
      var M = 'items[1]';
      var F = 'items[0]';
      var out = new FormData();
      formData.forEach(function (value, key) {
        if (key === 'id' || key === 'quantity' || key === 'selling_plan') {
          out.append(M + '[' + key + ']', value);
        } else if (key.indexOf('properties[') === 0) {
          if (key === 'properties[_gm_pz]' || key === 'properties[_gm_pz_fee]') return;
          out.append(M + '[properties]' + key.slice(10), value);
        } else {
          out.append(key, value);
        }
      });
      if (!out.has(M + '[quantity]')) out.append(M + '[quantity]', qty);
      out.append(M + '[properties][_gm_pz]', id);
      out.append(M + '[properties][_gm_pz_fee]', fee);
      out.append(F + '[id]', fee);
      out.append(F + '[quantity]', qty);
      out.append(F + '[properties][For]', formData.get('properties[Gymnast Name]') || '');
      out.append(F + '[properties][_gm_pz_for]', id);
      return out;
    }
  }

  if (!customElements.get('gm-personalise')) customElements.define('gm-personalise', GmPersonalise);

  function find(form) {
    return form ? form.querySelector('gm-personalise') : null;
  }

  // ---------- Cart: keep each NameTag fee line matched to its item ----------
  var syncing = false;
  var again = false;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function post(path, body) {
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) { return r.json(); });
  }

  function plan(cart) {
    var items = {};
    var fees = [];
    (cart.items || []).forEach(function (it) {
      var p = it.properties || {};
      if (p._gm_pz) {
        var e = items[p._gm_pz] || (items[p._gm_pz] = { qty: 0, fee: p._gm_pz_fee, name: p['Gymnast Name'] || '' });
        e.qty += it.quantity;
      } else if (p._gm_pz_for) {
        fees.push(it);
      }
    });
    var updates = {};
    var seen = {};
    var changed = false;
    fees.forEach(function (f) {
      var id = f.properties._gm_pz_for;
      var want = items[id] && !seen[id] ? items[id].qty : 0;
      seen[id] = true;
      if (f.quantity !== want) { updates[f.key] = want; changed = true; }
    });
    var adds = [];
    Object.keys(items).forEach(function (id) {
      var e = items[id];
      if (!seen[id] && e.fee) {
        adds.push({ id: Number(e.fee), quantity: e.qty, properties: { For: e.name, _gm_pz_for: id } });
      }
    });
    return { changed: changed || adds.length > 0, updates: updates, adds: adds };
  }

  function syncCart() {
    if (syncing) { again = true; return Promise.resolve(); }
    syncing = true;
    return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var p = plan(cart);
        if (!p.changed) return false;
        var step = Object.keys(p.updates).length ? post(cartUrl() + '/update.js', { updates: p.updates }) : Promise.resolve();
        return step
          .then(function () { return p.adds.length ? post(cartUrl() + '/add.js', { items: p.adds }) : null; })
          .then(function () { return true; });
      })
      .then(function (changed) {
        if (!changed) return;
        if (document.querySelector('cart-items:not(cart-drawer-items)') && /\/cart\/?$/.test(location.pathname)) {
          location.reload(); // cart page: totals live in another section, reload is simplest
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'gm-personalise' });
        }
      })
      .catch(function (e) { console.error('[gm-personalise] cart sync', e); })
      .finally(function () {
        syncing = false;
        if (again) { again = false; syncCart(); }
      });
  }

  function start() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (!event || event.source === 'gm-personalise' || event.source === 'product-form') return;
        syncCart();
      });
    }
    syncCart();
  }

  window.GymaticsPersonalise = {
    validate: function (form) {
      var el = find(form);
      return el ? el.validate() : null;
    },
    transform: function (form, formData) {
      var el = find(form);
      return el ? el.transform(formData) : formData;
    },
    syncCart: syncCart,
    _plan: plan,
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
